package com.evoapps.evoshift.data.dto.specialdays

import com.evoapps.evoshift.domain.model.LocalEvent
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

/**
 * `workplaces/{id}/local_events/{eventId}` (SH-227): ISO dates, so a period's events are a range
 * query; [workplaceId] for a collection-group analysis across workplaces.
 */
@Serializable
data class LocalEventDto(
    val name: String = "",
    val from: String = "",
    val to: String = "",
    val yearly: Boolean = false,
    val createdBy: String = "",
    val createdAt: String = "",
    val workplaceId: String = ""
) {
    /** Null when the dates are not dates or the name is empty. */
    fun toDomain(id: String, workplaceId: String): LocalEvent? {
        val start = runCatching { LocalDate.parse(from) }.getOrNull() ?: return null
        val end = runCatching { LocalDate.parse(to) }.getOrNull() ?: return null
        if (name.isBlank() || end < start) return null
        return LocalEvent(id, workplaceId, name, start, end, yearly, createdBy, createdAt)
    }

    companion object {
        fun of(event: LocalEvent, workplaceId: String) = LocalEventDto(
            name = event.name,
            from = event.from.toString(),
            to = event.to.toString(),
            yearly = event.yearly,
            createdBy = event.createdBy,
            createdAt = event.createdAt,
            workplaceId = workplaceId
        )
    }
}
